const baseURL = `${process.env.REACT_APP_API_BASE_URL}/api`
const baseURLForAda = `${process.env.REACT_APP_API_BASE_URL_ADA}/api`


// API to get email address while downloading pdf report
const GetUserEmailAPI = async (
    id: number, // scan id
    email: string, // email address
    reason: string, // selected reason to use accessibility checker
    other: string, // user inputted reason to use accessibility checker
): Promise<any> => {

    const url = `${baseURL}/compliance-report-request`;

    const data = new FormData();

    data.append("id", id.toString());
    data.append("email", email);
    data.append("report_purpose", reason);
    data.append("report_purpose_other", other);

    try {
        const response = await fetch(url, {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// API to get email address while downloading pdf report
const SendUserNewScanReportEmailAPI = async (
    id: string, // scan id
    websiteURL: string, // scan id,
    email:string
): Promise<any> => {

    const url = `${baseURLForAda}/checker/new-scan-report-email-updated`;
    console.log('new-scan-report-email-updated: ', email, id);

    const data = new FormData();

    data.append("domain", websiteURL.toString());
    data.append("email", email.toString());
    data.append("user_id", id.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}


// API to get email address while downloading pdf report
const SendUserNewScanRequestEmailAPI = async (
    id: string, // scan id
    websiteURL: string, // scan id
): Promise<any> => {

    const url = `${baseURLForAda}/checker/new-scan-request-email-updated`;
    console.log('new-scan-request-email-updated: ', id, websiteURL);

    const data = new FormData();

    data.append("domain", websiteURL.toString());
    data.append("user_id", id.toString());

    try {
        const response = await fetch(url, {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export {GetUserEmailAPI, SendUserNewScanRequestEmailAPI, SendUserNewScanReportEmailAPI}